import { FC } from 'react';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useCreateSubscriptionCheckoutSessionMutation } from '../api';
import { selectCurrentTeam } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';
import { CustomModal } from 'components';
import { NavCloseIcon } from 'assets/icons';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

interface StripeSubscriptionsModalProps {
  handleClose: (sessionId: string) => void;
  isFreeTrial: boolean;
  subscriptionPlanName: string;
}

const StripeSubscriptionsModal: FC<StripeSubscriptionsModalProps> = ({
  handleClose,
  isFreeTrial,
  subscriptionPlanName
}) => {
  const currentTeam = useAppSelector(selectCurrentTeam);
  const [createSubscriptionCheckoutSession, { data: checkoutSessionData }] =
    useCreateSubscriptionCheckoutSessionMutation();

  const fetchClientSecret = async () => {
    const response = await createSubscriptionCheckoutSession({
      teamId: currentTeam?.id,
      payload: { includeFreeTrial: isFreeTrial, subscriptionPlanName }
    }).unwrap();
    if (response?.data?.client_secret) {
      return response.data.client_secret;
    }
  };
  const options = { fetchClientSecret };

  const onClose = () => {
    handleClose(checkoutSessionData?.data?.session_id);
  };

  return (
    <>
      <CustomModal
        overlayClassName="bg-heading/80"
        open={true}
        enableOutsideClick={false}
        width="w-[90%] max-w-[516px] sm:w-[516px] md:w-[516px]"
        height="h-[90%] max-h-[650px] sm:h-[650px] md:h-[650px]"
        className="customNormalScroll overflow-auto p-2.5">
        <NavCloseIcon className="ml-auto cursor-pointer" onClick={onClose} />

        <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </CustomModal>
    </>
  );
};

export default StripeSubscriptionsModal;
